import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {InstitutionUnit} from "../../models/Institution-unit";
import {RegistrationUnit} from "../../models/registration-unit";
import Helpers from "../../utils/helpers";

@Injectable()
export class RegistrationUnitControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRegistrationUnits(registrationId: string) {
    return this.http.get(this.baseUrl + "registration/" + registrationId + "/registration_units");
  }

  public getRegistrationUnit(registrationUnitId: string) {
    return this.http.get(this.baseUrl + "registration_unit/" + registrationUnitId);
  }

  public getRegistrationUnitsByunitId(unitId: string): Observable<InstitutionUnit[]> {
    return this.http.get(this.baseUrl + "registration_unit_by_unit/" + unitId) as Observable<InstitutionUnit[]>;
  }

  public createRegistrationUnit(registrationId: string, registrationUnit: RegistrationUnit) {
    Helpers.trimRecursiveObj(registrationUnit);
    const body = JSON.stringify(registrationUnit);
    return this.http.post(this.baseUrl + "registration/" + registrationId + "/registration_unit", body);
  }

  public deleteRegistrationUnit<T>(registrationUnitId: string) {
    return this.http.delete(this.baseUrl + "registration_unit/" + registrationUnitId, {responseType: "text"});
  }

}
